export enum EventSubTypes {
  ECOMMERCE = "E-commerce",
  INTEGRATIONS = "Integrations",
  ACQUISITIONS = "Acquisitions",
  INBOX = "Inbox",
  ONLINE_STORE = "Online Store",
}
